import { useQuery } from '@tanstack/react-query';
import { getStoreAuthorizationPolicy } from 'services/api/admin';

/**
 * 当前组织的授权范围（新版订阅价区）。
 * 接口失败/未返回时 policy 为 undefined，站点与平台选项按不可授权处理。
 */
export const useAuthorizationPolicy = () => {
  const { data: policy, isLoading } = useQuery({
    queryKey: ['storeAuthorizationPolicy'],
    queryFn: () => getStoreAuthorizationPolicy(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  return { policy, isLoading };
};
